var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"serial_footer_wrapper"}},[_c('div',{attrs:{"id":"serial_bzbslogo"}},[_c('img',{attrs:{"src":require("@/assets/bzbslogo/bzbs-new-logo.svg")}})])])])
}]

export { render, staticRenderFns }